module.exports = __webpack_public_path__ + "static/media/space_astronaut.f5ac23ec.svg";